import { z } from "zod"

import { SortingOrder, TestTemplateComparison, TestTemplateSortField } from "@/graphql/codegen/graphql"

export enum TestTemplateResultsUom {
  Percent = "percent",
  DegreesC = "degrees C",
  Ppm = "ppm",
  Cp = "cP",
  Micrometer = "um",
  DegreesF = "degrees F",
  InLb = "in-lb",
  GPerKg = "g/kg",
  Seconds = "seconds",
  Min = "min",
  LbIn = "lb-in",
  M2PerG = "m2/g",
  MlPer100g = "mL/100g",
  Lbs = "LBS",
  GPerCm3 = "g/cm3",
  MgKOHPerG = "mg KOH/g",
  LbPerFt3 = "lb/ft3",
  Cst = "cSt",
  Mm = "mm",
  Dmm = "dmm",
  CgIPerG = "cg I/g",
  ShoreA = "Shore A",
  MgPerG = "mg/g",
  KgPerM3 = "kg/m3",
  MPaS = "mPa-s",
  GPer100g = "g/100g",
  Mesh = "mesh",
  CcPer50g = "cc/50g",
  G = "g",
  GPerMl = "g/mL",
  MlPerG = "mL/g",
  GPerG = "g/g",
  Ohm = "ohm",
  GPer10Min = "g/10 min",
  Cgs = "CGS",
  DnM = "dN.m",
  LbfIn = "lbf-in",
  Poise = "poise",
  WtPercent = "wt%",
  MgPerKg = "mg/kg",
  MolPerKg = "mol/kg",
  Cm = "cm",
  GPerEq = "g/eq.",
  GPerL = "g/L",
  GPerMol = "g/mol",
  LbsPerGal = "lbs/gal",
  MmolPerKg = "mmol/kg",
  USPerCm = "uS/cm",
  KgPerL = "kg/L",
  MlPer50g = "mL/50g",
  MmolPerG = "mmol/g",
  PaS = "Pa.s",
  PelletsPerG = "pellets/g",
  Unit = "unit",
  KgPerCm2 = "kg/cm2",
  Pounds = "pounds",
  ShoreD = "Shore D",
  Gardner = "Gardner",
  KU = "KU",
  LWUV = "LWUV",
  McdPerM2 = "mcd/m2",
  MeqPer100g = "meq/100g",
  APHA = "APHA",
  CcPer100g = "cc/100g",
  GPerS = "g/s",
  MgPerCc = "mg/cc",
  Ml = "mL",
  PtCo = "Pt-Co",
  Cm2PerG = "cm2/g",
  F = "F",
  Cc = "cc",
  GmPerCc = "gm/cc",
  Kg = "kg",
  CgIPerG_Alt = "cgI/g",
  Mol = "mol",
  Nm = "nm",
  Stokes = "stokes",
  Units = "units",
  PercentMPerM = "% m/m",
  PercentWt = "% wt",
  HundredMlPerGm = "100 mL/gm",
  CcPerG = "cc/g",
  CgPerCm3 = "cg/cm3",
  Cm3PerG = "cm3/g",
  C = "C",
  DlPerG = "dL/g",
  Ea = "ea",
  GPer100Ml = "g/100mL",
  Gl2Per100g = "gl2/100g",
  GmPer10Min = "gm/10min",
  MePerG = "me/g",
  MgPerK = "mg/k",
  MgPerM3 = "mg/m3",
  MlsNPer20 = "mls n/20",
  Mm2PerSec = "mm2/sec",
  OhmPerSq = "ohm/sq",
  Psi = "psi",
  Rpm = "rpm",
}

export const testTemplateSearchParamsSchema = z.object({
  field: z.nativeEnum(TestTemplateSortField).optional().default(TestTemplateSortField.CreatedOn),
  order: z.nativeEnum(SortingOrder).default(SortingOrder.Desc),
  query: z.string().optional(),
})

export const testTemplateFormSchema = z.object({
  description: z
    .string()
    .min(1, { message: "Description is required" })
    .max(25, { message: "Description must be less than 25 characters" }),
  comparison: z.union([z.nativeEnum(TestTemplateComparison), z.string().min(1, { message: "Comparison is required" })]),
  resultsUnitOfMeasure: z.string(),
})

export type TestTemplateFormValues = z.infer<typeof testTemplateFormSchema>
